import {textCheckSuccessfulAction, CheckSuccessfulPayload} from 'library/src/Store/PadState';
import {Dispatch, Middleware} from 'redux';
import {Action} from 'typescript-fsa';
// import {State} from 'FullVersion/Store'; TODO: fix store typings

// tslint:disable-next-line:no-any
export const removeStyleAdvicesMiddleware: Middleware<{}, any> = () =>
    (next: Dispatch) =>
        <A extends Action<{}>>(action: A): A => {
            if (action.type === textCheckSuccessfulAction.type) {
                const actionPayload = action.payload as CheckSuccessfulPayload;

                if (actionPayload.data) {
                    action.payload = {...action.payload, data: {spellAdvices: [...actionPayload.data.spellAdvices], styleAdvices: []}};
                }
            }
            // Call the next dispatch method in the middleware chain.
            return next(action);
        };
